import { Link } from "react-router-dom";
import { formatAthleteScore } from "./AthleteUtil";

export default function AthleteRow({ athlete }) {
  return (
    <Link
      to={`/athletes/${athlete.id}`}
      className="d-flex  w-100 py-1 text-decoration-none text-dark hover-bg-white"
    >
      <div className="flex-grow-1 pe-2 ps-1">
        {athlete.firstname} {athlete.lastname}
      </div>
      <div className="d-flex justify-content-end  pe-2">{athlete.category}</div>
      <div className="d-flex justify-content-end text-muted">
        {formatAthleteScore(athlete, "general")}
      </div>
    </Link>
  );
}
